import { render } from "./Table.vue?vue&type=template&id=4ffb63f8&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=4ffb63f8&lang=scss"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css"
import "@vueform/toggle/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "C:\\www\\Marta\\redadom.pl\\apartment-table\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__